import React, { useEffect, useState, useContext } from "react";
import useForm from "../../../../services/UseForm";
import '../../../../css/popUpForm.css';
import '../../../../css/temOrder.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { SaleProductContext } from "../SaleProduct";
axios.defaults.baseURL = API;

function TemSaleProductOrderByBarcode(props) {

    const {setSubTotal, showData, setShowData, setErrorMessage, setShowAlert} = useContext(SaleProductContext);

    const [ProductList, setProductList] = useState();

    const handleInputChange = event => {
        const { name, value } = event.target;
        if(value) 
            handleChange(name, value);
        else
            handleChange("Quantity", 1);
    };

    async function SearchProductByBarcode (event) {
        const { name, value } = event.target;
        let token = localStorage.getItem("token");
        if(value){
            handleChange(name, value);
            await axios.get(`/getInventoryByBarcode/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
                let productData = response?.data;
                if(productData.length > 0){
                    setProductList(productData);
                } else {
                    setProductList([]);
                }
            }).catch((err) => {
                console.log(err);
            });
        } else {
            handleChange(name, "");
            setProductList([]);
        }
    }

    async function addTemOrder(ProductID, Barcode, LaoName, EngName, BuyPrice, ProductType, Quantity) {
        if(ProductID > 0) {
            var c =0;
            for (var i=0; i < showData.length; i++) {
                if (showData[i].Barcode == Barcode) {
                    if(Number(Quantity) >= Number(showData[i].Quantity) + Number(values.Quantity)){
                        showData[i].Quantity = Number(showData[i].Quantity) + Number(values.Quantity);
                        showData[i].SubTotal = Number(showData[i].Quantity) * Number(showData[i].BuyPrice);
                        setSubTotal(Number(showData[i].Quantity) * Number(showData[i].BuyPrice));
                        localStorage.setItem("saleProductOrderData", JSON.stringify(showData));
                        c = 1;
                        break;
                    } else {
                        c = 1;
                        setErrorMessage("ຈຳນວນສິນຄ້າໃນສາງມີບໍ່ພຽງພໍ (ມີ: " + Quantity +' )');
                        setShowAlert(true);
                        break;
                    }  
                }
            }  
            if(c === 0){
                if(Number(Quantity) >= Number(values.Quantity)){
                    var SubTotal = BuyPrice;
                    if(values.Quantity > 1){
                        SubTotal = Number(values.Quantity) * Number(BuyPrice);
                    }
                    setSubTotal(SubTotal);
                    var list = {
                        ProductID: ProductID,
                        Barcode: Barcode,
                        EngName: EngName,
                        LaoName: LaoName,
                        BuyPrice: BuyPrice,
                        Quantity: values.Quantity,
                        SubTotal: SubTotal,
                        ProductType: ProductType,
                    }
                    showData.push(list);
                    localStorage.setItem("saleProductOrderData", JSON.stringify(showData));
                } else {
                    setErrorMessage("ຈຳນວນສິນຄ້າໃນສາງມີບໍ່ພຽງພໍ (ມີ: " + Quantity +' )');
                    setShowAlert(true);
                }
            }
            setOrderList();
        }
    }

    const setOrderList = () => {
        let userData = localStorage.getItem("saleProductOrderData");
        if (userData) {
            let userRole = JSON.parse(userData);
            setShowData(userRole);
            setProductList([]);
        } else
            setShowData([]);
    }

    const {
        values,
        handleChange,
    } = useForm();

    useEffect(() => {
        handleChange("Quantity", 1);
    }, []);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="TempForm">
                <div className="txtSearch">
                        <div className="txt">
                            <span>ຄົ້ນຫາດ້ວຍ Barcode</span>
                            <input className="input form-control"  type="text" name="Barcode" placeholder="ຄົ້ນຫາ" onChange={(e) => SearchProductByBarcode(e)} value={values.Barcode} />
                        </div>
                        <div className="Quantity">
                            <span>ຈຳນວນ</span>
                            <input className="input form-control"  type="text" name="Quantity" placeholder="1" onChange={(e) => handleInputChange(e)} value={values.Quantity || ''} required />
                        </div>
                        <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger btnBack" data-dismiss="modal" aria-label="Close">
                            ກັບຄືນ
                        </button>
                </div>
                <div className="TempContent">
                    {
                        ProductList && ProductList.map((x, y) => {
                            return (
                                <div key={y} className="TempItem" >
                                    <div className="TempBody">
                                        <div className="productName">
                                            <span>{(y+1) + '.'} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {x.LaoName}</span>
                                        </div>
                                        <div className="btnAdd"> 
                                            <button className="btn btn-success btnAdd" onClick={() => addTemOrder(x.ProductID, x.Barcode, x.LaoName, x.EngName, x.BuyPrice, x.ProductType, x.Quantity )} >ເພີ່ມ</button>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div >
        </div>
    );
};

export default TemSaleProductOrderByBarcode;
